import React from 'react';
import PropTypes from 'prop-types';
import { TooltipWrapper, TooltipContent } from './components/TooltipStyles';
import { useTooltip } from './hooks/useTooltip';
import { formatTooltipContent } from './utils/tooltipHelpers';

const Tooltip = ({ content, children, ...props }) => {
  const { isVisible, showTooltip, hideTooltip } = useTooltip();
  const displayContent = formatTooltipContent(content);

  return (
    <TooltipWrapper
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      {...props}
    >
      {children}
      <TooltipContent isVisible={isVisible}>{displayContent}</TooltipContent>
    </TooltipWrapper>
  );
};

Tooltip.propTypes = {
  content: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Tooltip/Tooltip.jsx